import { IFormInput } from "@gift/types";
import { Form } from "@gift/ui";
import { Authentication, useTranslation } from "@gift/utils";
import { useMemo, useState } from "react";

export interface IProps {
    emailAddress: string | undefined;
    onSubmit: () => void;
}

interface IFormData {
    emailAddress: string;
}

export const Form_PasswordReset: React.FC<IProps> = ({
    emailAddress,
    onSubmit,
}) => {
    const t = useTranslation();

    const [errorCode, setErrorCode] = useState<string>();

    const errorMessage = useMemo(
        () => (errorCode ? t(`errorMessage_${errorCode}`) : null),
        [errorCode],
    );

    const handleSubmit = ({ emailAddress }: IFormData) => {
        Authentication.sendPasswordResetEmail(emailAddress as string)
            .then(onSubmit)
            .catch((error) => {
                setErrorCode(error.code);
            });
    };

    return (
        <Form
            inputs={useMemo<IFormInput[]>(
                () => [
                    {
                        id: "emailAddress",
                        label: t("inputLabel_emailAddress"),
                        value: emailAddress,
                        controlType: "input",
                        rules: {
                            required: true,
                        },
                    },
                ],
                [t, errorMessage],
            )}
            buttonsRenderer={(submit) => [
                {
                    label: "Resetovat",
                    onClick: submit,
                },
            ]}
            onSubmit={handleSubmit}
        />
    );
};
